<template lang="pug">
  section.table-scroll
    table.rate-table
      tr(v-if="diffArrayData && diffArrayData.length > 0")
        template(v-for="rec in diffArrayData")
          th.vehicle-column {{ rec.vehicleTypeName }}

      template(v-for="col in diffArrayData")
        td(:class="getHistoryDiffCssClass(col.changeStatus)").price
          DigitSeparatorsLabel(:value="col.price")

</template>

<script>
import HistoryDiffCss from "@/mixin/HistoryDiffCss";
import DigitSeparatorsLabel from "@/components/common/DigitSeparatorsLabel";

export default {
  mixins: [HistoryDiffCss],
  components: {
    DigitSeparatorsLabel
  },
  props: {
    diffArrayData: {
      type: Array,
      required: false,
      default: () => null
    }
  }
};
</script>

<style scoped lang="stylus">
.rate-table {
  table-layout fixed
  width 100%
  .vehicle-column{
    width 100px
  }
}

td {
  height: 37px
}
</style>
